let CONSTS = {
	//静态常量放在这里
	BASE_URL: ""
}
//Vue CLI：在运行 npm run serve 时自动设置为 development，在运行 npm run build 时自动设置为 production。
//Vite：类似地，也会根据运行模式自动设置。
let env = process.env.NODE_ENV;
if (env == 'development') {
	CONSTS.BASE_URL = "http://221.10.90.140:8102/"  //生产环境服务器
	// CONSTS.BASE_URL = "http://localhost:8102" //开发环境服务器 
} else if (env == 'production') {
	CONSTS.BASE_URL = "http://221.10.90.140:8102/"
}
export default CONSTS